import React, { ReactNode } from "react";

type Props = {
  setShowConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  setShowLoader: React.Dispatch<React.SetStateAction<boolean>>;
  confirmSubmit: () => void;
  confirmationMessage: ReactNode;
};

const ConfirmationDialogue = ({
  setShowConfirmation,
  setShowLoader,
  confirmSubmit,
  confirmationMessage,
}: Props) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 relative w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Are you sure?</h2>
        <p className="mb-4 text-wrap">{confirmationMessage}</p>
        <div className="flex gap-4 justify-end">
          <button
            onClick={() => {
              setShowConfirmation(false);
              setShowLoader(false);
            }}
            className="p-2 bg-gray-400 text-white rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={confirmSubmit}
            className="p-2 bg-green-500 text-white rounded-md"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialogue;
